import React from 'react'

const Header = (props) => {
  return (
    <div>
      {props.name}
    </div>
  )
}

export default Header
